import apiClient from '../axiosInstance';
import { API_BASE_ADDRESS } from '../api';

import { getRecessStatusAction } from '../sagas/recess/recessStatusSaga';

// ユーザーメニューを取得します。
const recessStatusService = (action: getRecessStatusAction): any => {
  return {
    getRecessStatus: () => apiClient.get(`${API_BASE_ADDRESS}/mypage/member/${action.memberNo}/recess/status`),
  };
};

export default recessStatusService;
